import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {getEventTitle} from '@wix/wix-events-commons-statics'
import React from 'react'
import {LinkToPage} from '../../../../link-to-page'
import s from './title.scss'

interface TitleProps {
  event: wix.events.Event | Event_V3
}

export const Title = ({event}: TitleProps) => (
  <span className={s.title} data-hook="ev-list-item-title">
    <LinkToPage event={event} allowExternal>
      {getEventTitle(event)}
    </LinkToPage>
  </span>
)
